import { createPortal } from "react-dom";

function Toast({ message }) {
  return createPortal(<div className="toast">{message}</div>, document.body);
}

export default Toast;